import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

interface ArticleCardProps {
  id: string;
  title: string;
  summary: string;
  date: string;
  category: string;
  image: string;
  views: number;
}

export default function ArticleCard({
  id,
  title,
  summary,
  date,
  category,
  image,
  views,
}: ArticleCardProps) {
  const { t } = useTranslation();

  return (
    <Link
      to={`/article/${id}`}
      className="group flex flex-col sm:flex-row gap-4 bg-background-50 rounded-lg overflow-hidden no-underline hover:bg-background-100 transition-colors duration-200"
      title={title}
    >
      <div className="w-full sm:w-48 h-48 sm:h-32 flex-shrink-0 overflow-hidden bg-background-200">
        <img
          src={image}
          alt={`${title} 封面图`}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
      </div>
      <div className="flex-1 p-3 sm:p-0 sm:pr-4 sm:py-3 flex flex-col justify-between">
        <div>
          <div className="flex items-center gap-2 mb-1.5">
            <span className="text-xs text-primary-500 bg-primary-50 px-2 py-0.5 rounded-full font-medium">
              {category}
            </span>
            <span className="text-xs text-foreground-400">{date}</span>
          </div>
          <h3 className="text-sm font-semibold text-foreground-900 line-clamp-2 group-hover:text-primary-500 transition-colors">
            {title}
          </h3>
          <p className="text-xs text-foreground-500 mt-1.5 line-clamp-2">
            {summary}
          </p>
        </div>
        <div className="flex items-center gap-1 mt-2 text-xs text-foreground-400">
          <i className="ri-eye-line"></i>
          <span>{views.toLocaleString()} {t('article.views')}</span>
        </div>
      </div>
    </Link>
  );
}